import React from 'react';
import styled from 'styled-components';
import stateSettings from '@state/settings';
import SymbolBox from '@src/editor/components/SymbolBox';
import TextInput from '@src/editor/components/TextInput';
const Wrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;
const onSpacingSizeChange = (index) => (event) => {
    stateSettings.spacing[index] = event.target.value;
};
const SpacingSize = ({ spacing, index }) => (React.createElement(Wrapper, null,
    React.createElement(SymbolBox, null, spacing),
    React.createElement(TextInput, { name: `spacingSize_${index}`, label: "Spacing Size", value: spacing, onChange: onSpacingSizeChange(index) })));
export default SpacingSize;
